import {AxiosResponse} from "axios";
import AxiosApiInstance, {APIBase} from "../../../AxiosApiInstance";
import ApiBackReportModel from "./ApiBackReportModel";

export const ApiBackCampaignsReportGet: (campaign_pk: string, id: string) => Promise<AxiosResponse<ApiBackReportModel>> = (campaign_pk, id) => {
  return AxiosApiInstance.get(`${APIBase}back/campaigns/${campaign_pk}/reports/${id}/`);
};